import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Button, Modal } from "components/AtomsV2";
import { Icon } from "components/ShellV2";

/* Terms & Conditions modal shown from the login screen. Content lives in i18n
   (auth ns, `terms.*`); `terms.sections` is an array of { title, body[] }. */
function TermsModal({ open, onClose, onAccept }) {
  const { t } = useTranslation(["auth"]);
  const sections = t("terms.sections", { returnObjects: true });
  const list = Array.isArray(sections) ? sections : [];

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth={720}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            {t("terms.close")}
          </Button>
          <Button onClick={onAccept}>
            <Icon name="check" />
            {t("terms.accept")}
          </Button>
        </>
      }
    >
      <div className="flex items-start gap-3 mb-3">
        <span
          className="inline-flex items-center justify-center w-9 h-9 rounded-[10px] shrink-0"
          style={{
            background: "var(--accent-soft, rgba(16,181,160,.12))",
            color: "var(--accent-deep)",
          }}
        >
          <Icon name="gavel" fill />
        </span>
        <div className="min-w-0">
          <div className="text-[11px] font-semibold uppercase tracking-[0.06em] text-ink-3">
            {t("terms.modal_kicker")}
          </div>
          <h3 className="text-[18px] font-bold text-ink m-0">{t("terms.modal_title")}</h3>
        </div>
      </div>

      <div className="max-h-[58vh] overflow-y-auto pr-1">
        <div className="flex items-center gap-1 text-[12px] text-ink-3 mb-3">
          <Icon name="update" style={{ fontSize: 15 }} />
          {t("terms.updated_label", { date: t("terms.updated_date") })}
        </div>
        <p className="text-[13px] text-ink-2 leading-[1.6] mb-4">{t("terms.intro")}</p>
        {list.map((s) => (
          <section key={s.title} className="mb-4">
            <h4 className="text-[13.5px] font-semibold text-ink mb-1">{s.title}</h4>
            {(s.body || []).map((p) => (
              <p key={p} className="text-[13px] text-ink-2 leading-[1.6] mb-1.5">
                {p}
              </p>
            ))}
          </section>
        ))}
      </div>
    </Modal>
  );
}

TermsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAccept: PropTypes.func,
};

TermsModal.defaultProps = {
  open: false,
  onClose: undefined,
  onAccept: undefined,
};

export default TermsModal;
